var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestFifth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 16 18",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v20h-20z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#181818",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("rect", {
    height: 3.333333,
    rx: 1,
    width: 6.666667,
    x: 6.666667,
    y: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.3500688 4.1925h1.6666666-.0083333c.9166667-.00833333 1.6666667.74166667 1.6666667 1.65833333v9.99999997c0 .9166667-.75 1.6666667-1.6666667 1.6666667h-9.99999999l-.00833333-.0008333c-.925-.0083334-1.66673545-.75-1.66673545-1.675v-10.00000003c-.00826455-.925.74173545-1.675 1.65840212-1.675h1.66666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.0583333 10.8333333-2.32499997 2.325-1.4-1.4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestFifth);
export default __webpack_public_path__ + "static/media/request-fifth.6d0dea35c63d5ccdfd050a2b18bc4570.svg";
export { ForwardRef as ReactComponent };